import { app } from "./app";
import { screenConfig } from "./screens";

class DataImporter {
    constructor() {
        this.data = {
            config: null,
            game: null
        };

        this.currMission = null;
        this.currPack = null;
        this.currMap = null;

        this.basePath = nick_sdk_client.JSEmbedProxy.getBase() || "";
    }

    setupConfig() {
        app.assets.bank.push({
            name: "data",
            assets: ["assets/config/game.json", "assets/config/config.json"],
            tags: ["config"]
        });
        app.assets.bank.push({
            name: "brand-logo",
            isSoloImg: true,
            assets: ["assets/atlases/static/brand-logo.png"],
            tags: ["logo"]
        });
    }

    onConfigLoaded(cb) {
        this.loadCb = cb;
        this.data.config = app.loader.resources[this.basePath + "assets/config/config.json"].data;
        this.data.game = app.loader.resources[this.basePath + "assets/config/game.json"].data;
        this.loadManifests(this.data.config.packs);
        this.loadPacks(this.data.config.packs);
        app.assets.addAssetsWithTags(["loader", "config"]);
    }

    loadManifests(packs) {
        let manifestLocations = [];
        for (var i = 0; i < packs.length; i++) {
            app.assets.bank.push({
                name: packs[i] + "_atlas",
                assets: ["packs/" + packs[i] + "/atlases/atlas-manifest.json"],
                tags: ["common", "config"]
            });
            manifestLocations.push("packs/" + packs[i] + "/atlases/atlas-manifest.json");
        }
        app.loader.once("complete", () => {
            this.onManifestsLoaded(manifestLocations);
        });
    }

    loadPacks(packs) {
        let packLocations = [];

        for (var i = 0; i < packs.length; i++) {
            app.assets.bank.push({
                name: packs[i] + "_pack",
                assets: ["packs/" + packs[i] + "/pack.json"],
                tags: ["common", "config"]
            });
            packLocations.push("packs/" + packs[i] + "/pack.json");
        }

        app.loader.once("complete", () => {
            this.onPacksLoaded(packLocations);
        });
    }

    onPacksLoaded(packlocations) {
        this.packs = [];
        let maps = [];

        for (var i = 0; i < packlocations.length; i++) {
            let pack = app.loader.resources[this.basePath + packlocations[i]].data;
            this.packs.push(pack);

            this.loadExternalAssets(pack.externalAssets, "packs/" + pack.id + "/");

            pack.world.maps.forEach(map => {
                maps.push({ map: map, pack: pack });
            });
        }

        this.loadMaps(maps);
        // this.onComplete();
    }

    loadMaps(maps) {
        let mapLocations = [];
        for (var i = 0; i < maps.length; i++) {
            let mapPath = "packs/" + maps[i].pack.id + "/" + maps[i].map.data;
            app.assets.bank.push({
                name: maps[i].map.id + "_map",
                assets: [mapPath],
                tags: ["common", "config"]
            });
            mapLocations.push(this.basePath + mapPath);
        }

        app.loader.once("complete", () => {
            this.onMapsLoaded(maps, mapLocations);
        });

        app.assets.addAssetsWithTags(["loader", "config", "logo"]);
    }

    loadExternalAssets(assetsToLoad, basePath) {
        if (assetsToLoad && assetsToLoad.length > 0) {
            for (let i = 0; i < assetsToLoad.length; i++) {
                const assetConfig = assetsToLoad[i];

                // Add base path to all assets.
                for (let j = 0; j < assetConfig.assets.length; j++) {
                    assetConfig.assets[j] = basePath + assetConfig.assets[j];
                }

                app.assets.bank.push(assetConfig);
            }
        }
    }

    onManifestsLoaded(locations) {
        for (var i = 0; i < locations.length; i++) {
            app.assets.parseManifest(app.loader.resources[this.basePath + locations[i]].data);
        }
    }

    onMapsLoaded(maps, mapLocations) {
        for (let i = 0; i < maps.length; i++) {
            let map = app.loader.resources[mapLocations[i]].data;
            maps[i].pack.world.maps[maps[i].pack.world.maps.indexOf(maps[i].map)].data = map;
        }
        this.onComplete();
    }

    onComplete() {
        this.loadCb();
    }
}

export let dataImporter = new DataImporter();
